import { cn } from '@/shared/utils/utils';

export interface LeaderboardRow {
  name: string;
  value: string;
  /** 0-100, drives the progress bar width. */
  pct: number;
}

// Rank is carried by the numeral's weight, not by three different hues — the
// old gold/bronze literals were off-palette and the middle one failed contrast.
const RANK_TONE = ['text-on-surface', 'text-on-surface-variant', 'text-on-surface-variant'];

function initials(name: string) {
  return name.split(' ').map((w) => w[0]).filter(Boolean).slice(0, 2).join('').toUpperCase();
}

export function Leaderboard({ rows, className }: { rows: LeaderboardRow[]; className?: string }) {
  if (rows.length === 0) {
    return <p className="py-8 text-center text-body-sm text-on-surface-variant">No one has a figure in this window yet. Widen the period to see the ranking.</p>;
  }
  return (
    <div className={cn('flex flex-col gap-3', className)}>
      {rows.map((row, i) => (
        <div key={row.name} className="flex items-center gap-3">
          <span className={`w-5 shrink-0 text-center font-mono text-data-md tabular-nums ${RANK_TONE[i] || RANK_TONE[2]}`}>
            {i + 1}
          </span>
          <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-card-sm bg-surface-variant text-data-xs font-semibold text-on-surface-variant">
            {initials(row.name)}
          </span>
          <div className="min-w-0 flex-1">
            <div className="flex items-center justify-between gap-2">
              <span className="truncate text-data-md font-medium text-on-surface">{row.name}</span>
              <span className="shrink-0 font-mono text-data-md tabular-nums text-on-surface">{row.value}</span>
            </div>
            <div className="mt-1.5 h-1.5 overflow-hidden rounded-full bg-surface-variant">
              <div className="h-full rounded-full bg-primary/70" style={{ width: `${Math.max(0, Math.min(100, row.pct))}%` }} />
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}
